import toast from 'react-hot-toast';

/**
 * Открывает URL в новой вкладке с параметрами запроса, обнуляя opener для безопасности.
 * @param {string} url - Базовый URL.
 * @param {object} [params] - Параметры запроса (ключ-значение).
 */
function openSafeLink(url, params) {
  const queryString = Object.entries(params || {})
    .map(([key, value]) => (Array.isArray(value) ? value.map((item) => `${key}=${item}`).join('&') : `${key}=${value}`))
    .join('&');

  const fullUrl = queryString ? `${url}?${queryString}` : url;

  const newTab = window.open(fullUrl, '_blank');

  if (newTab) {
    newTab.opener = null;
  } else {
    toast.error('Не удалось открыть новую вкладку.');
  }
}

export default openSafeLink;
